import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import SimpleHeader from '../../headers/simpleHeader';
import { addCustomerImage } from '../actions';
import CustomerForm from '../customerForm';
import { prepareCustomerForSave } from '../helpers';

class AddCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: null,
      disabled: false,
      initialValues: {
        firstName: '',
        lastName: '',
        notifications: {
          confirm: {
            email: true,
            phone: true,
            push: true,
          },
          reschedule: {
            email: true,
            phone: true,
            push: true,
          },
          cancel: {
            email: true,
            phone: true,
            push: true,
          },
          barber_reminder: {
            email: true,
            push: false,
            time: {
              hours: 24,
              minutes: 0,
            },
          },
          reminder: {
            email: true,
            phone: true,
            push: true,
            time: {
              hours: 1,
              minutes: 0,
            },
          },
        },
      },
    };
  }

  saveCustomer = (model) => {
    const {
      saveCustomer,
      saveCustomerImage,
      router,
      redirectUrl,
    } = this.props;

    this.setState({
      disabled: true,
    });

    let avatar = null;
    if (model.avatar) {
      avatar = model.avatar;
      delete model.avatar;
    }

    // Deletes any (not nested) key-value pair
    // where value is an empty string
    // (API doesn't accept empty strings)
    for (const key in model) {
      if (model[key] === '') {
        delete model[key];
      }
    }

    saveCustomer(prepareCustomerForSave(model))
    .then((customer) => {
      if (!avatar) {
        router.push(redirectUrl);
        return Promise.resolve();
      }
      saveCustomerImage(customer.id, avatar).then(() => {
        this.setState({
          disabled: false,
        });
        router.push(redirectUrl);
      })
      .catch((error) => {
        this.setState({
          errors: error.message,
          disabled: false,
        });
      });
    }).catch((error) => {
      this.setState({
        errors: error.message,
        disabled: false,
      });
    });
  };

  render() {
    const {
      initialValues,
      disabled,
      errors,
    } = this.state;

    return (
      <div>
        <SimpleHeader heading="Add client" />
        <div className="c-wrapper">
          <div
            className="u-margin-auto u-max-width-710"
            display-if={errors}
          >
            <div className="c-login-error-message u-mb u-mt">
              { errors }
            </div>
          </div>
          <CustomerForm
            saveCustomer={this.saveCustomer}
            initialValues={initialValues}
            className="u-margin-auto u-color-white u-max-width-710"
            disabled={disabled}
            redirectUrl={this.props.redirectUrl}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  saveCustomerImage: addCustomerImage,
};

AddCustomer.propTypes = {
  saveCustomer: PropTypes.func.isRequired,
  saveCustomerImage: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  redirectUrl: PropTypes.string.isRequired,
};

export default connect(
  null,
  mapDispatchToProps
)(withRouter(AddCustomer));
